// convert route pathname map to meaningful breadcrumb name
export const breadcrumbNameMap = {
  'user-management': 'Kullanıcı Yönetimi',
  'user-list': 'Kullanıcı Listesi',
  'add-user': 'Kullanıcı Ekle',
  'edit-user': 'Kullanıcı Düzenle',
  'customer-management': 'Müşteri Yönetimi',
  'customer-list': 'Müşteri Listesi',
  'customer-contact-us': 'Bize Ulaş',
  'customer-detail': 'Müşteri Bilgileri',
  'customer-agreements': 'Müşteri Sözleşmeleri',
  'customer-pharmacies': 'Müşteri Kayıtlı Eczaneleri',
  'customer-orders': 'Müşteri Siparişleri',
  'order-management': 'Sipariş Yönetimi',
  'order-list': 'Sipariş Listesi',
  'campaign-management': 'Kampanya Yönetimi',
  'campaign-list': 'Kampanyalar Listesi',
  'add-campaign': 'Kampanya Ekle',
  'edit-campaign': 'Kampanya Güncelle',
  'campaign-pharmacies': 'Eczane Yönetimi',
  'pharmacy-management': 'Eczane Yönetimi',
  'pharmacy-list': 'Eczane Listesi',
  'add-pharmacy': 'Eczane Ekle',
  'edit-pharmacy': 'Eczane Güncelle',
  'pharmacy-users-list': 'Eczane Kullanıcı Listesi',
  'add-pharmacy-user': 'Eczane Kullanıcısı Ekle',
  'edit-pharmacy-user': 'Eczane Kullanıcısı Güncelle',
  'pharmacy-support': 'Eczane Destek',
  'pharmacy-support-list': 'Eczane Destek Listesi',
  'product-management': 'Ürün Yönetimi',
  'products-list': 'Ürün Listesi'
};

// User-Profile Role name mapper func.
export const roleNameMapper = (userRole, roles) => {
  const userRoleName = roles.find(role => role.id === userRole)?.name || '-';

  return userRoleName;
};

// General Status Mapper
export const mapActivationStatus = id => {
  switch (id) {
    case 1:
      return { text: 'Aktif', color: 'success' };
    case 2:
      return { text: 'Pasif', color: 'danger' };
    default:
      return;
  }
};

// Customer Gender Mapper
export const mapGenderInfo = id => (id === 1 ? 'Kadın' : 'Erkek');

// Customer Language  Mapper
export const mapLanguageInfo = id => (id === 1 ? 'Türkçe' : 'İngilizce');

// Customer - Agreements Publish Statuses
export const mapAgreementPublishStatus = id => {
  switch (id) {
    case 1:
      return 'Taslak';
    case 2:
      return 'Yayınlanmış';
    case 3:
      return 'Yayınlanmamış';
    default:
      return;
  }
};

// Customer - Order Delivery Types
export const mapDeliveryTypes = id => {
  switch (id) {
    case 1:
      return 'Adrese Teslim';
    case 2:
      return 'Eczaneden Teslim';
    default:
      return;
  }
};

// Customer - Order Statuses
export const mapOrderStatuses = id => {
  switch (id) {
    case 1:
      return { text: 'Bekliyor', color: '' };
    case 2:
      return { text: 'Kabul Edildi', color: 'info' };
    case 3:
      return { text: 'Hazırlanıyor', color: 'warning' };
    case 4:
      return { text: 'Tamamlandı', color: 'success' };
    case 5:
      return { text: 'İptal Edildi', color: 'danger' };
    default:
      return;
  }
};

// Customer Support Subjects
export const customerSupportSubjects = id => {
  switch (id) {
    case 1:
      return 'Kampanyalar';
    case 2:
      return 'Eczane Detay - Bilgileri';
    case 3:
      return 'Soru';
    case 4:
      return 'Şikayet';
    case 5:
      return 'Diğer';
    default:
      return;
  }
};
